var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckeditor"},[_c('textarea',{attrs:{"name":_vm.name,"id":_vm.id,"types":_vm.types,"config":_vm.config},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }